export const SET_GROUPS = 'SET_GROUPS';
export const SET_RANGE = 'SET_RANGE';
export const SET_DATA = 'SET_DATA';
export const SET_DATA_LOADING = 'SET_DATA_LOADING';
export const SET_GROUP_LOADING = 'SET_GROUP_LOADING';
export const SET_DATA_FINALIZING = 'SET_DATA_FINALIZING';
export const SET_GROUP_BY = 'SET_GROUP_BY';
export const SET_SELECTED_TEAMS = 'SET_SELECTED_TEAMS';
export const CALCULATE_GROUP_SCORES = 'CALCULATE_GROUP_SCORES';
export const CALCULATE_ALL_GROUPS_VITALITY = 'CALCULATE_ALL_GROUPS_VITALITY';
export const DISPLAY_FULLSCREEN_LOADING = 'DISPLAY_FULLSCREEN_LOADING';

// Show/hide Sensei hints
export const SHOW_SENSEI_CRITERIA = 'SHOW_SENSEI_CRITERIA';
// Show/hide Welcome msg
export const SHOW_WELCOME = 'SHOW_WELCOME';

export default {
  SET_GROUPS,
  SET_RANGE,
  SET_DATA,
  SET_DATA_LOADING,
  SET_GROUP_LOADING,
  SET_DATA_FINALIZING,
  SET_GROUP_BY,
  SET_SELECTED_TEAMS,
  CALCULATE_GROUP_SCORES,
  CALCULATE_ALL_GROUPS_VITALITY,
  DISPLAY_FULLSCREEN_LOADING,

  SHOW_SENSEI_CRITERIA,

  SHOW_WELCOME,
};
